export enum UserType {
    Unassigned,
    JJR,
    Council
}

export interface Profile {
    costPerCameraMinute: number;
    councilSiteNumber: string;
    hasAgreedToTermsAndConditions: boolean;
    organisation: string;
    userType: string;
    isFreeUser: boolean;
}
